import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Icons, User, UserType, Project, Partecipant, PartecipantType, ProjectData, ProjectService, FileGeneratorService, Tender } from 'toolbandi-ui-lib';
import { CrudService, MessageService, SharedDataService, Breadcrumb, Search, download, AclService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { ProjectEditComponent } from '../project-edit/project-edit.component';
import { DialogService } from 'elbuild-ui-componentslib';
import { FileGeneratorOption } from 'toolbandi-ui-lib/lib/model/file-generator.model';
@Component({
	selector: 'app-project-view',
	templateUrl: './project-view.component.html',
	styleUrls: ['./project-view.component.scss']
})
export class ProjectViewComponent implements OnInit, OnDestroy {

	loading: boolean = false;
	project: Project;
	projectdata: ProjectData;
	showgeneralcosts: boolean;
	tender: Tender;

	get projectdatakeys(): string[] {
		let keys = (this.projectdata && this.projectdata.jsondata) ? Object.keys(this.projectdata.jsondata) : [];
		keys = keys.filter(k => k !== 'consistency' && k !== 'objective' && k !== 'otherobjective');
		return keys;
	}

	keys: string[];
	canvalidate: boolean;
	breadcrumb: Breadcrumb;


	@ViewChild('nav', {}) nav: NgbNav;
	@ViewChild('nav2', {}) nav2: NgbNav;
	@ViewChild('nav3', {}) nav3: NgbNav;
	partecipants: Partecipant[];


	partecipantType = PartecipantType;
	isCompany: boolean;

	usercompanyid: number;
	error: boolean;
	badge: { style: string; text: string; };

	generatorOptions: FileGeneratorOption[];
	exporting: boolean;

	progressBarMax: number;
	progressBarCurrent: number;


	constructor(
		private projectService: CrudService<Project>,
		private tenderService: CrudService<Tender>,
		private projectDataService: CrudService<ProjectData>,
		private partecipantService: CrudService<Partecipant>,
		private projecteditService: ProjectService,
		private fileGeneratorService: FileGeneratorService,
		private dialogService: DialogService,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private modalService: NgbModal,
		private aclService: AclService) {

		this.sharedDataService.currentLoggedUser.subscribe((data) => {
			if (data) {

				this.canvalidate = ((data as unknown as User).utype === UserType.admin);
				const user: User = data as User;
				this.isCompany = user.utype === UserType.company;
				this.usercompanyid = this.isCompany ? user.companyid : undefined;
			}
		});


		this.aclService.hasPermission('generalcosts').subscribe((r: boolean) => {
			this.showgeneralcosts = r;
		});
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			this.load(id);
			this.loadPartecipants(id);

		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.projectService.getEntity(Project, 'project', id).subscribe(project => {
			this.project = project;

			this.loadTender(project.tenderid);

			const search = new Search('projectdata');
			search.addSimpleFilter('projectid', this.project.id);

			this.projectDataService.searchEntities(ProjectData, 'projectdata', search, search.page).subscribe((pd: ProjectData) => {
				if (pd[0]) {
					this.projectdata = pd[0];
					this.projectdata.jsondata = JSON.parse(this.projectdata.jsondata as string);
				} else {
					this.projectdata = undefined;
				}

			});

			this.loading = false;
			if (this.project) {
				this.error = false;
				this.createKeys();
				this.setBreadcrumb();

			} else {
				this.error = true;
			}

		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.project'));
			this.project = undefined;
			this.loading = false;
			this.error = true;
		});
	}


	loadTender(id: number) {
		this.tenderService.getEntity(Tender, 'tender', id).subscribe((t: Tender) => {
			this.tender = t;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.project'));
		});
	}

	loadPartecipants(id: number) {
		this.partecipantService.getFiltered(Partecipant, 'partecipant', 'projectid', id + '').subscribe(data => {
			this.partecipants = data;
			this.progressBarMax = this.partecipants.map(p => p.realbudget).reduce((a, b) => a + b, 0);
			this.progressBarCurrent = this.partecipants.map(p => p.currentcost).reduce((a, b) => a + b, 0);
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.project'));
			this.project = undefined;
			this.loading = false;
		});
	}


	setBreadcrumb() {

		this.breadcrumb = new Breadcrumb();
		this.breadcrumb.breadcrumbitems = [
			{ title: 'labels.companies', url: '/company' },
			{ title: this.project.company.name, url: '/company/view/' + this.project.company.id, icon: Icons.COMPANY, icontooltip: 'labels.company' },
		];
		this.badge = { style: this.project.statuscolor, text: 'labels.' + this.project.status };
		this.breadcrumb.title = { title: 'labels.view-project', param: this.project.name, icon: Icons.PROJECT, icontooltip: 'labels.project' };
	}

	createKeys(): void {
		this.keys = Object.keys(this.project);
		const exclude = ['insdate', 'budget', 'moddate', 'companyid', 'company', 'tender', 'tenderid', 'id', 'startdate', 'enddate', 'senddate', 'description'];
		this.keys = this.keys.filter(k => this.project[k] && exclude.indexOf(k) < 0);
	}


	attachmentsChanged(): void {
		/*if (this.project && this.project.id) {
			this.projectService.getEntity(Project, 'project', this.project.id).subscribe(project => {
				this.project.docvalid = project.docvalid;
				this.breadcrumb.addData('docinvalid', !this.project.docvalid);
			}, ({ error }) => {

			});
		}*/
	}

	edit(): void {
		const modal = this.modalService.open(ProjectEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.companyid = this.project.companyid;
		modal.componentInstance.load(this.project.id);

		modal.result.then((newItem: Project) => {
			this.load(this.project.id);
		}).catch(() => { });
	}

	present() {

		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-project-present'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.projecteditService.present(this.project).subscribe(() => {
					this.translateService.get(['labels.activitycost-deleted', 'labels.activitycosts']).subscribe(response => {
						const messages = this.translateService.instant(['labels.project-save-success', 'labels.success']);
						this.messageService.sendSuccess(messages['labels.project-save-success'], messages['labels.success']);
						this.load(this.project.id);
					});
				}, ({ error }) => {
					this.messageService.sendError(error, this.translateService.instant('labels.project'));

				});
			}
		});

	}
	archive() {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-archive-present'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.projecteditService.archive(this.project).subscribe(() => {
					this.translateService.get(['labels.activitycost-deleted', 'labels.activitycosts']).subscribe(response => {
						const messages = this.translateService.instant(['labels.project-save-success', 'labels.success']);
						this.messageService.sendSuccess(messages['labels.project-save-success'], messages['labels.success']);
						this.load(this.project.id);
					});
				}, ({ error }) => {
					this.messageService.sendError(error, this.translateService.instant('labels.project'));

				});
			}
		});
	}
	close() {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-project-close'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.projecteditService.close(this.project).subscribe(() => {
					this.translateService.get(['labels.activitycost-deleted', 'labels.activitycosts']).subscribe(response => {
						const messages = this.translateService.instant(['labels.project-save-success', 'labels.success']);
						this.messageService.sendSuccess(messages['labels.project-save-success'], messages['labels.success']);
						this.load(this.project.id);
					});
				}, ({ error }) => {
					this.messageService.sendError(error, this.translateService.instant('labels.project'));

				});
			}
		});

	}

	reject() {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-reject-present'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.projecteditService.reject(this.project).subscribe(() => {
					this.translateService.get(['labels.activitycost-deleted', 'labels.activitycosts']).subscribe(response => {
						const messages = this.translateService.instant(['labels.project-save-success', 'labels.success']);
						this.messageService.sendSuccess(messages['labels.project-save-success'], messages['labels.success']);
						this.load(this.project.id);
					});
				}, ({ error }) => {
					this.messageService.sendError(error, this.translateService.instant('labels.project'));

				});
			}
		});
	}

	openFileGeneratorModal(content: any) {
		this.fileGeneratorService.getPrintOptions().subscribe(result => {
			console.log('result', result);
			this.generatorOptions = result;
			this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
		}, error => {
			this.messageService.sendError(error.error.msg);
		});

	}

	download(option: FileGeneratorOption) {
		this.exporting = true;
		this.fileGeneratorService.generate(option, this.project).subscribe(result => {
			if (result) {
				let filename = option.label.toLocaleLowerCase().split(' ').slice(1).join('_') + '-' + this.project.name.toLocaleLowerCase().split(' ').join('_');
				filename += '_' + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString();
				download(result, `${filename}.${option.type}`);
			}
			this.exporting = false;
		}, error => {
			this.exporting = false;
			this.messageService.sendError(error.error.user_message, error.error.errcode);
		});
	}


	addPartecipant(partecipant: Partecipant): void {
		this.partecipants.push(partecipant);
	}

	deletePartecipant(partecipant: Partecipant): void {
		this.partecipants = this.partecipants.filter(p => p.id !== partecipant.id);
	}


	opentab(iscompany: boolean, id: string): void {
		if (iscompany && this.nav2 && id) {
			this.nav2.select(id);

		} else
			if (!iscompany && this.nav3 && id) {
				this.nav3.select(id);

			}
	}


}
